var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offset-line",class:[_vm.offsetBottom ? 'offset-bottom' : '']})
}
var staticRenderFns = []

export { render, staticRenderFns }